import { $patchStyleText } from '@lexical/selection';
import { Button, Typography } from '@mui/material';
import { $getSelection, $isRangeSelection } from 'lexical';
import React from 'react';
import { Icons } from '../../icons/Icons';
import { H } from '../../Layout';
import { useStyling } from '../../Theme';
import { fontSizeKey, LexicalToolbarProps } from '../lexicalConstants';

export default function LexicalFontSizeToolbar({
    disabled = false,
    editor,
    currentFontSize
}: LexicalToolbarProps & { currentFontSize: string }) {
    const fontSize = currentFontSize ? parseInt(currentFontSize, 10) : 14;
    const { theme } = useStyling();
    const handleFontSizeChange = (newSize: number) => {
        editor.update(() => {
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                $patchStyleText(selection, {
                    [fontSizeKey]: `${newSize}px`
                });
            }
        });
    };

    const increment = () => {
        handleFontSizeChange(fontSize + 1);
    };

    const decrement = () => {
        if (fontSize > 1) {
            handleFontSizeChange(fontSize - 1);
        }
    };

    return (
        <H sx={{ width: 'fit-content' }}>
            <Button
                disabled={disabled || fontSize <= 1}
                onClick={decrement}
                variant="text"
                size="small"
                sx={{ minWidth: 'auto', p: 0.5, color: theme.palette.text.secondary, borderRadius: 0 }}
                aria-label="Decrease font size"
            >
                <Icons.RemoveButton />
            </Button>
            <Typography
                fontSize={14}
                textAlign={'center'}
                sx={{
                    minWidth: '32px',
                    height: '25px',
                    border: '1px solid',
                    borderColor: 'divider',
                    p: '2px',
                    borderRadius: 0.5,
                    color: theme.palette.text.secondary
                }}
                aria-label="Current font size"
            >
                {fontSize}
            </Typography>
            <Button
                disabled={disabled}
                onClick={increment}
                variant="text"
                size="small"
                sx={{ minWidth: 'auto', p: 0.5, color: theme.palette.text.secondary, borderRadius: 0 }}
                aria-label="Increase font size"
            >
                <Icons.AddButton />
            </Button>
        </H>
    );
}
